import { css, type Theme } from '@emotion/react';

export const content = (theme: Theme) => css`
  width: 100%;
  min-height: 100dvh;
  background-color: ${theme.colors.primary[15]};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
  padding: 24px;

  @media (max-width: ${theme.breakpoints.medium}) {
    gap: 20px;
    padding: 20px;
  }

  @media (max-width: ${theme.breakpoints.small}) {
    justify-content: flex-start;
    gap: 16px;
    padding: 16px;
  }
`;

export const title = (theme: Theme) => css`
  color: ${theme.colors.primary[500]};
  text-align: center;

  font-size: 28px;
  line-height: 1.2;

  @media (max-width: ${theme.breakpoints.medium}) {
    font-size: 24px;
  }

  @media (max-width: ${theme.breakpoints.small}) {
    font-size: 20px;
  }
`;

export const button = (theme: Theme) => css`
  width: 100%;
  max-width: 406px;

  display: flex;
  justify-content: center;
  align-items: center;
  height: 44px;

  @media (max-width: ${theme.breakpoints.tiny}) {
    height: 40px;
  }
`;

export const imageContainer = (theme: Theme) => css`
  aspect-ratio: 319 / 219;
  width: 100%;
  max-width: 319px;

  @media (max-width: ${theme.breakpoints.medium}) {
    max-width: 280px;
  }

  @media (max-width: ${theme.breakpoints.small}) {
    max-width: 240px;
  }

  & > img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    display: block;
  }
`;
